import { FeatureToggleClientService } from 'feature-toggle-client';
import { ReportConstants } from './ReportConstants';
export class ReportFeatures {
    static isTextRewriteEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ReportConstants.TEXT_REWRITE);
    }
}
